import { Link, useNavigate } from 'react-router-dom';
import type { ThreadActionProposalSummary, ThreadTopicSummary } from '@shared/types/thread-work';
import { useKeyShortcut } from '@/lib/use-key-shortcut';

/** A tool proposal opens the tool with the exact proposal; run-flow revalidates
 * it against the actor's own app Thread before accepting it. */
export const AppToolProposalLink = ({ topic, proposal, label, className, hotkey }: {
  topic: ThreadTopicSummary;
  proposal: ThreadActionProposalSummary;
  /** Short verb for dense lists; the proposal's label stays as the tooltip. */
  label?: string;
  className?: string;
  /** In a séance, the key that opens it. */
  hotkey?: string;
}) => {
  const navigate = useNavigate();
  const to = `/tools/${encodeURIComponent(proposal.executorKey)}`;
  const state = {
    toolPrefill: proposal.prefill ?? {},
    threadProposalHandoff: {
      proposalId: proposal.id, topicId: topic.id, expectedTopicVersion: topic.version,
      topicTitle: topic.title, subjectId: null, accountSubjectId: null,
    },
  };
  useKeyShortcut(hotkey ?? '', () => navigate(to, { state }), Boolean(hotkey));
  return <Link
    className={className ?? 'mt-3 inline-flex items-center rounded-lg bg-domino-aubergine px-4 py-2 text-sm font-semibold text-white hover:bg-domino-prune'}
    title={label ? proposal.ctaLabel : hotkey ? `Raccourci : ${hotkey.toUpperCase()}` : undefined}
    to={to}
    state={state}
  >
    {label ?? proposal.ctaLabel}
  </Link>;
};
